(() => {
  const init = (root) => {
    root.querySelectorAll('[data-heritage-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-heritage-track]');
      const previous = carousel.querySelector('[data-heritage-previous]');
      const next = carousel.querySelector('[data-heritage-next]');
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const step = (direction) => {
        const card = track.querySelector('.bd-heritage-stories__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };
      previous.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
